<template>
  <div class="data-list-container" ref="mainProductsTable">
    <columns-manager
    :isPromptActive="IsPromptActive.columnsManager"
    :HideableColumns="Columns"
    :isHidden="isHidden"
    @updatePromptColumns="isHidden = $event;"
    @closePromptColumns="IsPromptActive.columnsManager = false;"
    />

    <addNewProductSidebar
      :isSidebarActive="IsPromptActive.addNewProduct"
      :allProducts="Products"
      @modifySidebar="IsPromptActive.addNewProduct = $event"
      ref='NewProduct'
    />

    <modifyStock
      :isPromptActive="IsPromptActive.modifyStock"
      :Product="ModifyStockProduct"
      @closePrompt="IsPromptActive.modifyStock = false"
      @updateStock="updateStockPrompt($event)"
      @restartPrompt="IsPromptActive.modifyStock = false; myAlert('Alerta', $event, 'warning', ()=>{ IsPromptActive.modifyStock = true; })"
    />

    <vs-table ref="table" pagination :data="filteredProducts" :max-items="itemsPerPage" :noDataText="defaultNoDataText" search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" style="padding-bottom: 14px;">
        <div class="flex flex-wrap-reverse items-center">

          <!-- Columns Manager -->
          <vs-button color="primary" type="filled" class="columnsManagerBtn" @click="manageColumns()">
            <font-awesome-icon icon="columns"/>
          </vs-button>

          <div v-if="MainCofig.selectedAdminProfile == 'admin'">

            <!-- New product -->
            <vs-button class="mr-3" color="primary" type="border" @click="startNewProduct(0)">
              <font-awesome-icon icon="plus"/>
              Nuevo producto
            </vs-button>


            <!-- Modify price -->
            <vs-button @click="editingPrice = !editingPrice;" type="border" class="mr-3"
            :color="!editingPrice ?  'primary' : 'danger'">
              <font-awesome-icon icon="edit"/>
              {{ !editingPrice ? 'Modificar precios' : 'Dejar de modificar precios' }}
            </vs-button>

            <!-- Modify stock -->
            <!-- <vs-button @click="editingStock = !editingStock;" type="border" class="mr-3"
            :color="!editingStock ?  'primary' : 'danger'">
              <font-awesome-icon icon="edit"/>
              {{ !editingStock ? 'Modificar stock' : 'Dejar de modificar stock' }}
            </vs-button> -->


            <!-- Copy list -->
            <vs-button @click="copyProductsList()" type="border" class="mr-3" color="primary">
              <font-awesome-icon :icon="['far', 'copy']"/>
              Copiar lista
            </vs-button>

            <!-- Filter -->

            <v-select v-model="selectedFilteredBy" style="display: inline-block; width: 170px"
            :options="filteredByOptions" :reduce="name => name.id" label="name"
            ></v-select>

          </div> <!-- v-if is admin -->

        </div>

        <items-per-page
        :itemsLength="filteredProducts.length"
        :currentPage="currentPage"
        :itemsPerPage="itemsPerPage"
        @newItemsPerPage="itemsPerPage = $event"/>
      </div> <!-- header -->


      <template slot="thead">
        <vs-th v-for="Col in Columns" v-if="!isHidden[Col.name]" :class="Col.nowrap == false ? '' : 'nowrap'">
          {{ Col.title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <!-- Filtros por columna -->
        <!-- <vs-tr>
          <vs-td v-for="Col in Columns" v-if="!isHidden[Col.name]">
            <div class="inputContainer" style="position: relative">
              <vs-button type="border" size="small" class="tableFilterBtn narrowBtn">
                <font-awesome-icon icon="filter"/>
              </vs-button>
              <vs-input type="text" class="tableFilterInput"/>
            </div>
          </vs-td>
        </vs-tr> -->

        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <!-- id -->
          <vs-td v-if="!isHidden.id" :data="tr.id" class="autoWidth">
            <vs-chip color="primary">{{ tr.id }}</vs-chip>
          </vs-td>
          <!-- Functions -->
          <vs-td v-if="!isHidden.functions" class="nowrap autoWidth">
            <div v-if="MainCofig.selectedAdminProfile == 'admin'">
              <button type="button" class="functionBTN" @click="startEditProduct(tr)">
                <font-awesome-icon icon="edit"/>
              </button>
              <button type="button" class="functionBTN" @click="startEditStock(tr)">
                <font-awesome-icon icon="edit"/>
                Stock
              </button>
              <button type="button" class="functionBTN" @click="startNewProduct(tr.detailsID)">
                <font-awesome-icon icon="plus"/>
                Variante
              </button>
            </div> <!-- v-if is admin -->

            <vs-button v-else type="border" @click="startEditStock(tr)">
              <font-awesome-icon icon="edit"/>
              Stock
            </vs-button>
          </vs-td>
          <!-- Img -->
          <vs-td v-if="!isHidden.img" class="autoWidth">
            <div class="imgContainer" style="position: relative;">
              <img :src="getImgDual(`${tr.id}-1`)">
              <div class="isNewLabel" v-if="tr.isNew">Nuevo</div>
            </div>
          </vs-td>
          <!-- name -->
          <vs-td v-if="!isHidden.name" :data="tr.fullName">{{ tr.fullName }}</vs-td>
          <!-- price -->
          <vs-td v-if="!isHidden.price" :data="getRealPrice(tr)" :class="getRealPriceType(tr)" class="nowrap">

            <div v-if="editingPrice">
              <vs-input class="newPriceInput price"  v-model="tr.price"  @change="updatePrice(tr)" icon-no-border icon="attach_money" type="number" @focus="$event.target.select()"/>
              <vs-input class="newPriceInput offert" v-model="tr.offert" @change="updatePrice(tr)" icon-no-border icon="attach_money" type="number" @focus="$event.target.select()"/>
            </div>
            <span v-else>$ {{ getRealPrice(tr) }}</span>

          </vs-td>
          <!-- Stock -->
          <vs-td v-if="!isHidden.stock" :data="tr.stock" class="centered">

            <div v-if="editingStock">
              <vs-input class="newPriceInput price"  v-model="tr.stock"      @change="updateStock(tr)" icon-no-border type="number" @focus="$event.target.select()"/>
              <vs-input class="newPriceInput offert" v-model="tr.stockAlert" @change="updateStock(tr)" icon-no-border type="number" @focus="$event.target.select()"/>
            </div>
            <vs-chip v-if="tr.hasInfiniteStock" :color="getStockColor(2, 1)">
              <font-awesome-icon icon="infinity"/>
            </vs-chip>
            <vs-chip v-else :color="getStockColor(tr.stock, tr.stockAlert)" class="nowrap">
              <span v-if="!isHidden.stock" class="stockOfStockAlert">
                {{ `${tr.stock} /  ${tr.stockAlert}` }}
              </span>
            </vs-chip>

          </vs-td>

          <!-- brand -->
          <vs-td v-if="!isHidden.brand" :data="tr.brand" class="centered">{{ tr.brand }}</vs-td>


          <!-- archive -->
          <vs-td v-if="!isHidden.delete" class="autoWidth">
            <vs-button type="border" color="danger" class="narrowBtn" @click="archiveProduct(tr, indextr)">
              <font-awesome-icon :icon="['far', 'folder-open']"/>
            </vs-button>
          </vs-td>

          <!-- delete -->
          <vs-td v-if="!isHidden.delete" class="autoWidth">
            <vs-button type="border" color="danger" class="narrowBtn" @click="deleteProduct(tr)">
              <font-awesome-icon :icon="['far', 'trash-alt']"/>
            </vs-button>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>

  </div>
</template>










<!-- - - - - - - - - - - - - - - - SCRIPT - - - - - - - - - - - - - - - -->
<script>
// mixins
import { vsTableConfig } from '@/mixins/vsTableConfig.js';
// components
import vSelect from 'vue-select';
export default {
  mixins: [vsTableConfig],
  components: {
    'v-select': vSelect,
    addNewProductSidebar: () => import('./components/products/AddNewProduct.vue'),
    modifyStock: () => import('./components/products/ModifyStock.vue'),
  },
  data() {
    return {
      Products: [],
      IsPromptActive: { addNewProduct: false, modifyStock: false, },
      NewProductDetailsID: 0,
      ModifyStockProduct: { id: 0, name: '', stock: 0, },
      editingPrice: false,
      editingStock: false,
      selectedFilteredBy: 1,
      filteredByOptions: [
        { id: 1, name: 'Normal' },
        { id: 2, name: 'Archivados' },
        { id: 3, name: 'Sin stock' },
        { id: 4, name: 'Stock < 0' },
      ],
      // static
      itemsPerPage: 50,
      Columns: [
        { name: 'id'        , title: 'ID', },
        { name: 'functions' , title: 'Funciones', },
        { name: 'img'       , title: 'Img', },
        { name: 'name'      , title: 'Nombre', },
        { name: 'price'     , title: 'Precio', },
        { name: 'stock'     , title: 'Stock', },
        { name: 'brand'     , title: 'Marca', },
        { name: 'archived'  , title: 'Archivar', },
        { name: 'delete'    , title: 'Eliminar', },
      ],
      selectedProfile: 1,
      Profiles: [
        /* 00 - Testing */ [],
        /* 01 - Admin */ [ 'id', 'brand', ],
        /* 02 - Gestión */ ['id', 'brand', 'delete', ],
      ],
    };
  }, // DATA
  computed: {
    filteredProducts: function() {
      if (this.selectedFilteredBy == null) this.selectedFilteredBy = 1;
      switch (this.selectedFilteredBy) {
        // Normal
        case 1:
          // Prod.stock != 0 || Prod.price == 0
          return this.Products.filter(i => !i.isArchived);
          break;
        // Archived
        case 2:
          return this.Products.filter(i => (i.isArchived))
          break;
        // No stock or no price
        case 3:
          return this.Products.filter(i => (!i.isArchived && (!i.stock || !i.price)))
          break;
        // Stock < 0
        case 4:
          return this.Products.filter(i => (this.getStock(i) < 0))
          break;
      }
    },
  },
  watch: {
    // onlyNoStock: function() {
    //   this.checkShowProduct();
    // },
    // onlyArchived: function() {
    //   this.checkShowProduct();
    // },
    currentPage(val) {
      this.paginationPageChange(val);
    },
  }, // WATCH
  created() {
    // this.currentPage = 1;
    this.loadProducts();
  }, // CREATED
  methods: {
    // archiveProduct
    // checkShowProduct
    // copyProductsList
    // deleteProduct
    // filterProducts
    // loadProducts
    // modifyProductDB
    // modifyProductDetailsDB
    // updateStock
    // paginationPageChange
    // startEditProduct
    // startEditStock
    // startNewProduct
    // updatePrice
    // updateSiblings


    copyProductsList() {
      let msg = 'Lista copiada correctamente';
      let text = '';
      for (let Prod of this.filteredProducts) {
        text += `• ${Prod.fullName}: $${this.showPrice(Prod.price)}\r\n`;
      }
      this.copyToClipboard(text, msg);
    },
    archiveProduct(Prod, index) {
      if (Prod.stock) {
        alert('No podés archivar un producto con stock');
        return;
      }
      if (!confirm(`¿Seguro que querés archivar "${Prod.fullName}"?`)) return;
      let Params = { productID : Prod.id, isArchived: 1 };
      this.modifyProductDB(Params);
      Prod.isArchived = true;
      for (var i = 0; i < this.Products.length; i++) {
        if (this.Products[i].id == Prod.id) {
          this.filteredProducts;
          this.Products.splice(i, 1); // Delete the item from array
        }
      }
    },
    deleteProduct(Prod) {
      if (Prod.stock) {
        alert('No podés eliminar un producto con stock');
        return;
      }
      if (!confirm(`¿Seguro que querés eliminar "${Prod.fullName}"?`)) return;
      let Params = { productID : Prod.id, isActive: 0 };
      this.modifyProductDB(Params);
      for (var i = 0; i < this.Products.length; i++) {
        if (this.Products[i].id == Prod.id) {
          this.Products.splice(i, 1); // Delete the item from array
        }
      }
    },
    // filterProducts
    filterProducts: function() {
      return;
      console.log(this.selectedFilteredBy);
      switch (this.selectedFilteredBy) {
        // Normal
        case 1:
          // Prod.stock != 0 || Prod.price == 0
          this.filteredProducts = this.Products.filter(i => !i.isArchived);
          break;
        // Archived
        case 2:
          this.filteredProducts = []
          // this.filteredProducts = this.Products.filter(i => (i.isArchived))
          break;
        // No stock or no price
        case 3:
          this.filteredProducts = this.Products.filter(i => (!i.isArchived && (!i.stock || !i.price)))
          break;
      }
    },
    loadProducts() {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getProduct', params:  { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Products:');
          console.log(res.data.data);
          vm.Products = res.data.data;
          for (let Prod of vm.Products) {
            Prod.price = vm.showPrice(Prod.price);
            Prod.offert = vm.showPrice(Prod.offert);
            Prod.newStock = Prod.stock;
            Prod.newStockAlert = Prod.stockAlert;
          }
          vm.filterProducts();
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    modifyProductDB(Params){
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'modifyProduct', params:  Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    modifyProductDetailsDB(Params){
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'modifyProductDetails', params:  Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    updateStock(Params) {
      for (let i in this.Products) {
        if (this.Products[i].id == Params.productID) {
          this.Products[i].stock = Params.stock;
          return;
        }
      }
    },
    updateStockPrompt(Params) {
      let index = this.Products.findIndex((i) => i.id == Params.productID);
      this.Products[index].stock = Params.newStock;
    },
    paginationPageChange(value) {
      let position = this.$refs.mainProductsTable.offsetTop;
      this.myScrollTo(position-80);
    },
    startEditProduct(Product) {
      this.$refs.NewProduct.startEditProduct(Product);
      this.IsPromptActive.addNewProduct = true;
    }, // startEditProduct()
    startEditStock(Product) {
      this.ModifyStockProduct.name = Product.fullName;
      this.ModifyStockProduct.stock = Product.stock;
      this.ModifyStockProduct.id = Product.id;
      this.IsPromptActive.modifyStock = true
    },
    startNewProduct(detailsID) {
      this.$refs.NewProduct.startNewProduct(detailsID);
      this.IsPromptActive.addNewProduct = true;
    },
    updatePrice(Product) {
      Product.price = this.showPrice(Product.price);
      Product.offert = this.showPrice(Product.offert);
      this.updateSiblings(Product);
      let Params = {
        detailsID: Product.detailsID,
        price: Product.price,
        offert: Product.offert,
      }
      this.modifyProductDetailsDB(Params);
    },
    updateStock(Prod) {
      Prod.newStock = this.parseInt(Prod.newStock);
      let stockDiference = Prod.newStock - Prod.stock;
      let stockAlertDiference = Prod.newStockAlert - Prod.stockAlert;
      if (!stockDiference) {
        // Modify stock
        let Params = {
          product: Prod.id,
          amount: stockDiference,
          websiteZoneID: this.dataDB.StockChangesWebsiteZoneIDs.masiveStockChanger,
        }
        // Modify old value, for the next change
        Prod.stock = Prod.newStock;
        // updateDB
        this.updateProductStock(Params);
      } else if (stockAlertDiference) {
        // Modify stock
        // Product.stock = this.parseInt(Product.stock);
        // let Params = {
        //   product: Product.id,
        //   amount: Product.price,
        //   offert: Product.offert,
        //   websiteZoneID: this.dataDB.StockChangesWebsiteZoneIDs.masiveStockChanger,
        // }
        // this.updateProductStock(Params);
      }
    },
    updateSiblings(UpdatedProd) {
      for (let Prod of this.Products) {
        if (Prod.detailsID == UpdatedProd.detailsID) {
          Prod.price = UpdatedProd.price;
          Prod.offert = UpdatedProd.offert;
        }
      }
    }
  }, // METHODS
}
</script>


<style lang="css" scoped>
.newPriceInput {
  width: 110px;
  display: inline-block;
}
.newPriceInput:last-of-type {
  margin-left: 10px;
}
.price {
  color: STEELBLUE;
}
.offert {
  color: INDIANRED;
  font-weight: 600;
}
.functionBTN {
  border-left: 0;
  border-radius: 0;
}
.functionBTN:first-of-type  {
  border-left: solid 1px;
  border-radius: 5px 0 0 5px;
}
.functionBTN:last-of-type {
  border-radius: 0 5px 5px 0;
}
.inputContainer {
  width: 100%;
  /* padding-left: 40px; */
}
.tableFilterBtn {
  position: absolute;
  left: 0;
  height: 37px;
  z-index: 10;
}
/* /deep/ .tableFilterInput div input { */
.tableFilterInput {
  padding-left: 50px;
  width: 100%;
}




</style>
